export default "__VITE_ASSET__DPu9FB9R__"